import styled from 'styled-components';
import Colors from 'assets/Colors.js';
import Constants from 'helpers/constants';

const BodyContainer = styled.div`
  max-width: 1057px;
  margin: auto;
  margin-top: 38px;
  padding-left: 12px;
  padding-right: 12px;
  padding-bottom: 49px;
`;

const container = styled.div`
  padding: 13px 23px 16px 23px;
  width: 97%;
  margin: 0 auto;
  box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.06), 0px 2px 6px rgba(0, 0, 0, 0.04),
    0px 0px 1px rgba(0, 0, 0, 0.04);
`;

const containerBody = styled.div`
  padding: 13px 23px 16px 23px;
  width: 583px;
  margin: 0 18px;
  @media (max-width: ${Constants.pxBreakPoint}px) {
    width: unset;
    margin-right: 0px;
    padding: 0 10px
  }
`;

const InputContainerFullWidth = styled.div`
  background: ${Colors.background_dividers};
  width: 583px;
  display: flex;
  flex-direction: column;
`;

const searchContainer = styled.div`
  display: flex;
  margin-right: 13px;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  border: 0.5px solid ${Colors.background_dividers};
  flex-direction: column;
`;

const SectionTitle = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  display: flex;
  align-items: center;
  letter-spacing: 0.01em;
  color: ${Colors.primary};
`;
const Line = styled.div`
  background: ${Colors.background_dividers};
  height: 1px;
  width: 100%;
`;
const LeftContainer = styled.div`
  width: 583px;
  margin-right: 88px;
  margin-bottom: 53px;
  @media (max-width: ${Constants.pxBreakPoint}px) {
    width: unset;
    margin-right: 0px;
  }
`;
const SubTitle = styled.div`
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 22px;
  color: ${Colors.primary};
  margin-bottom: 8px;
`;
const SectionTitle2 = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
  color: ${Colors.primary};
  margin-bottom: 9px;
`;
const LittleMessage = styled.div`
  font-style: normal;
  font-weight: 300;
  font-size: 10px;
  line-height: 18px;
  color: ${Colors.text_secondary};
  margin-bottom: 28px;
`;
const RightContainer = styled.div`
  width: 357px;
  margin-bottom: 53px;
  @media (max-width: ${Constants.pxBreakPoint}px) {
    width: unset;
  }
`;
const TopSectionsContainer = styled.div`
  display: flex;
  @media (max-width: ${Constants.pxBreakPoint}px) {
    flex-direction: column;
  }
`;
const ImageContainer = styled.div`
  background: ${Colors.ARTICLE_PICTURE_OFF};
  display: grid;
  place-content: center;
  border-radius: 5px;
  height: 137px;
  width: 137px;
  margin-right: 29px;
`;
const PhotoSectionMiddle = styled.div`
  display: flex;
  align-items: center;
`;
const TextImageContainer = styled.div`
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 21px;
  color: ${Colors.text_primary};
`;
const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 600px) {
    margin-bottom: 20px;
  }
`;

const gridInputContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 0 10px;
  margin-bottom: 27px;
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const button = styled.div`
  opacity:  ${(props) =>
    (props.disabled  && "0.5")};
  border: 1px solid ${Colors.primary};
  width: 169px;
  height: 40px;
  color: ${Colors.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  pointer-events: ${(props) => (props.disabled ? 'none' : 'all')};
  @media (max-width: 640px) {
    margin-bottom: 20px;
  }
`;

const buttonsave = styled.div`
  background: ${(props) =>
    (props.disabled == false ? Colors.icon_secondary : Colors.primary)};
  border: 1px solid
    ${(props) =>
    (props.disabled == false ? Colors.icon_secondary : Colors.primary)};
  width: 169px;
  height: 40px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${(props) => (props.disabled == false ? 'not-allowed' : 'pointer')};
  pointer-events: ${(props) => (props.disabled == false ? 'none' : 'all')};
`;
const groupRadio = styled.div`
  display: flex;
  border-radius: 2px;
  padding-left: 18px;
  align-items: center;
  height: 40px;
  width: 381px;
  align-items: center;
  border: 0.5px solid ${Colors.background_dividers};
  background-color: ${(props) => props.color};
`;

const messageAlert = styled.p`
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 21px;
  color: ${Colors.notification_failed};
`;

const textUnvalid = styled.div`
  margin-top: 18px;
  display: flex;
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 21px;
  color: ${Colors.text_secondary};
`;

const storeHoursSpan = styled.span`
  font-weight: 300;
  font-style: italic;
`;

const spantextUnvalid = styled.div`
  margin-left: 5px;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
  color: ${Colors.text_secondary};
`;

const storeHours = styled.div`
  font-weight: 500;
  font-size: 15px;
`;

const message = styled.div`
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 21px;
  color: ${Colors.text_secondary};
`;

const containerRow = styled.div``;

const containerButton = styled.div`
  display: flex;
  @media (max-width: 640px) {
    display: block;
  }
`;

const tooltip = styled.div`
  font-style: normal;
  width: 480px;
  height: 80px;
  z-index: 1;
  background: #fff;
  font-weight: 300;
  font-weight: 300;
  font-size: 12px;
  line-height: 21px;
  color: ${Colors.text_secondary};
  margin-top: 18px;
  border-radius: 2px;
  padding: 5px;
  border: 1px solid ${Colors.text_secondary};
  // visibility: hidden;
  position: absolute;
  left: 350px;
  top: 265px;
  :hover {
    background: red;
  }
`;

export default {
  BodyContainer,
  SectionTitle,
  Line,
  LeftContainer,
  SubTitle,
  LittleMessage,
  SectionTitle2,
  RightContainer,
  TopSectionsContainer,
  ImageContainer,
  PhotoSectionMiddle,
  TextImageContainer,
  InputContainer,
  gridInputContainer,
  button,
  buttonsave,
  groupRadio,
  messageAlert,
  containerRow,
  containerButton,

  container,
  searchContainer,
  containerBody,
  storeHoursSpan,
  storeHours,
  message,

  textUnvalid,
  spantextUnvalid,
  tooltip,

  InputContainerFullWidth,
};
